import addCustomTextColor from './add-custom-text-color';

export default {
  addCustomTextColor,
};
